export const normalizeWhatsAppPhone = (value) => {
    if (value === null || value === undefined) {
        return '';
    }

    if (
        typeof value === 'number'
        && (!Number.isFinite(value) || !Number.isInteger(value) || value < 0)
    ) {
        return '';
    }

    const rawPhone = String(value).trim();
    if (!rawPhone) {
        return '';
    }

    const plusMatches = rawPhone.match(/\+/g) || [];
    if (
        plusMatches.length > 1
        || (plusMatches.length === 1 && !rawPhone.startsWith('+'))
    ) {
        return '';
    }

    const phoneWithoutPrefix = rawPhone.startsWith('+')
        ? rawPhone.slice(1)
        : rawPhone;

    if (!phoneWithoutPrefix || !/^[\d\s().-]+$/.test(phoneWithoutPrefix)) {
        return '';
    }

    const digits = phoneWithoutPrefix.replace(/[\s().-]/g, '');
    return /^\d{8,15}$/.test(digits) ? digits : '';
};

export const buildWhatsAppUrl = (phone, message) => {
    const normalizedPhone = normalizeWhatsAppPhone(phone);
    if (!normalizedPhone) {
        return '';
    }

    const normalizedMessage = String(message ?? '');
    return `https://api.whatsapp.com/send?phone=${normalizedPhone}&text=${encodeURIComponent(normalizedMessage)}`;
};
